import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchTournaments } from '../actions';
import TournamentTile from './TournamentTile';
import AdminNavigationBar from './AdminNavigationBar';

class AdminDashboard extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchTournaments());
  }

  render() {
    return (
      <div>
        <AdminNavigationBar />
        <div className="container col-md-6">
          <h1>Moje turnieje</h1>
          <div className="d-flex justify-content-end mt-3 mb-3">
            <Link to="/admin/tournaments/new"><button className="btn btn-primary">Nowy turniej</button></Link>
          </div>
          <div>
            {this.tournamentList()}
          </div>
        </div>
      </div>
    );
  }

  tournamentList() {
    const tournaments = this.props.tournaments;

    if (tournaments) {
      return (
        <div>
          {
            tournaments.map(tournament =>
              <TournamentTile tournament={tournament} link={'/admin/tournaments/' + tournament.id + '/participants'} />
            )
          }
        </div>
      );
    } else {
      return (<p>Brak turniejów.</p>);
    }
  }
}

function mapStateToProps(state) {
  return { tournaments: state.tournaments };
}

export default connect(mapStateToProps)(AdminDashboard);



// WEBPACK FOOTER //
// ./components/AdminDashboard.js